import { useQuery, useIsFetching, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import getLoggedUser from '../../utils/react-query/query-options/get-logged-user';

export const useIsUserValidating = () => {
  const isServiceBox = process.env.NEXT_PUBLIC_TENANT === '5';
  const isFetching = useIsFetching({
    queryKey: ['user-dependent', 'logged-user'],
  });
  return isServiceBox && isFetching > 0;
};

const useLoggedUser = () => {
  const { locale = 'en', push, pathname } = useRouter();
  const queryClient = useQueryClient();
  const isRunningLocalTests =
    process.env.NEXT_PUBLIC_HOST?.includes('localhost');
  const {
    data: user,
    isError,
    isLoading,
  } = useQuery(...getLoggedUser({ locale }), {
    refetchOnWindowFocus: 'always',
    refetchInterval: 60000,
    refetchOnMount: true,
    cacheTime: Infinity,
    staleTime: Infinity,
    onSuccess: (data) => {
      if (data && process.env.NEXT_PUBLIC_TENANT === '5') {
        // Service Box needs the cart refetched once the session resolves.
        // Never invalidate this query's own key here: `invalidateQueries`
        // refetches active queries regardless of `staleTime`, so it would
        // re-trigger this `onSuccess` in an endless loop.
        queryClient.invalidateQueries({
          queryKey: ['user-dependent', 'cart'],
        });
      }
    },
    onError: (err: any) => {
      if (err?.status === 403 && process.env.NEXT_PUBLIC_TENANT === '5') {
        if (isRunningLocalTests) {
          push(`/login`);
        } else {
          push(`/sb/error`);
        }
      }
    },
  });

  if (isLoading) {
    return undefined;
  }

  if (isError) {
    return null;
  }

  return user;
};

export default useLoggedUser;
